import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IUserParam } from "../models/userparam.model";

@Injectable()
export class UserParamService {
    public getInitialTaskData(): Observable<IUserParam[]> {
        return of([]);
    }
}